import { Star } from "lucide-react";

const TIER_CLS = {
  Gold: "bg-yellow-500 text-black",
  Silver: "bg-slate-300 text-slate-900",
  Standard: "bg-slate-600 text-white",
};

export function loyaltyText(l) {
  if (!l) return null;
  const free =
    l.availableFreeNights > 0
      ? `${l.availableFreeNights} free night${l.availableFreeNights > 1 ? "s" : ""} ready`
      : `${l.pointsToNextFree} pts to a free night`;
  return `${l.tier} • ${l.pointsBalance} pts • ${free}`;
}

export function TierBadge({ tier }) {
  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${TIER_CLS[tier] || TIER_CLS.Standard}`}>
      {tier}
    </span>
  );
}

export default function LoyaltyBadge({ loyalty, className = "" }) {
  if (!loyalty) return null;
  return (
    <div
      data-testid="loyalty-status"
      className={`flex items-center gap-2 rounded-lg border border-[#A0148C]/50 bg-[#A0148C]/10 px-3 py-2 ${className}`}
    >
      <Star className="h-4 w-4 shrink-0 text-[#A0148C]" />
      <span className="text-sm font-semibold text-slate-100">{loyaltyText(loyalty)}</span>
    </div>
  );
}
